<input class="search"
       id="{{name+'search__input'|slug}}"
       [value]="searchText"
       (input)="onSearchChange($event)"
       [placeholder]="placeholder">
